export default function Switch({
                                   h2Title = true,
                                   firstLabel,
                                   secondLabel,
                                   checked = false,
                                   classes = {},
                                   onChange = () => {
                                   }
                               }) {

    const {firstLabelClasses = "", secondLabelClasses = "", checkedClass = "", barClasses = ""} = classes

    return (
        <div className="flex items-center">
            <label className="flex items-center">
                {
                    h2Title ? <h2 className={`font-semibold ml-5 ${firstLabelClasses}`}>{firstLabel}</h2> :
                        <p className={`font-semibold ml-5 ${firstLabelClasses}`}>{firstLabel}</p>
                }

                <div className="relative inline-block switch w-11 h-3.5">
                    <input type="checkbox"
                           className="peer opacity-0 w-0 h-0"
                           onChange={onChange}
                           checked={checked}/>
                    <span className={`rounded-xl ${checkedClass ? "peer-checked:" + checkedClass : ""} peer-focus:shadow-2xl absolute cursor-pointer inset-0 duration-300
                                        peer-checked:before:translate-x-8 before:absolute before:rounded-full before:h-[1.875rem] before:w-[1.875rem] before:-left-[0.5rem] before:-bottom-2 before:duration-300 ${barClasses}`}/>

                </div>
                {
                    h2Title ? <h2 className={`font-semibold mr-6 ${secondLabelClasses}`}>{secondLabel}</h2> :
                        <p className={`font-semibold mr-6 ${secondLabelClasses}`}>{secondLabel}</p>
                }

            </label>
        </div>
    )
}
